module.exports = __webpack_public_path__ + "media/assets/images/category/Thanksgiving@2x-b1f7372f158ae1b5cb358f065b6f2269.png";